import { useVisibleT } from "@/lib/cms/cms-new-i18n";
import type { ShortcutIcon } from "@/lib/dashboard-home/shortcuts";
import { cn } from "@/lib/utils";
import { Check, Plus } from "lucide-react";
import { SHORTCUT_ICONS } from "../shortcut-icons";

/** Ligne cliquable d'un choix (action, page) avec son état à droite. */
export const PickerRow = ({
  icon,
  label,
  used,
  selected = false,
  disabled = false,
  onSelect,
}: {
  icon: ShortcutIcon;
  label: string;
  /** Déjà dans les raccourcis : affichée cochée, non cliquable. */
  used: boolean;
  selected?: boolean;
  disabled?: boolean;
  onSelect: () => void;
}) => {
  const vt = useVisibleT();
  const Icon = SHORTCUT_ICONS[icon];
  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={used || disabled}
      aria-pressed={selected}
      className={cn(
        "group flex w-full min-w-0 items-center gap-3 rounded-lg border px-3 py-2 text-left text-sm transition-colors",
        selected
          ? "border-primary bg-brand-50"
          : "border-slate-200 hover:border-primary hover:bg-brand-50",
        "disabled:cursor-default disabled:border-slate-200 disabled:bg-slate-50 disabled:hover:bg-slate-50",
      )}
    >
      <Icon
        className={cn(
          "size-4 shrink-0",
          used ? "text-slate-400" : "text-primary",
        )}
        aria-hidden
      />
      <span
        className={cn(
          "min-w-0 flex-1 leading-snug [overflow-wrap:anywhere]",
          used && "text-slate-500",
        )}
      >
        {label}
      </span>
      {used ? (
        <span className="flex shrink-0 items-center gap-1 text-xs text-slate-500">
          <Check className="size-3.5" aria-hidden />
          {vt("bo.home.shortcuts.added", "Ajouté")}
        </span>
      ) : (
        <Plus
          className="size-4 shrink-0 text-slate-400 group-hover:text-primary group-disabled:hidden"
          aria-hidden
        />
      )}
    </button>
  );
};
